export default "__VITE_ASSET__C6nhUw2F__"